var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgXLogo = function SvgXLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo 1",
    clipPath: "url(#clip0_50_227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.969 11.1117L22.7069 0.95459H20.6363L13.0491 9.7739L6.9893 0.95459H0L9.16366 14.2909L0 24.9423H2.07073L10.083 15.6288L16.4826 24.9423H23.4719L13.9684 11.1117H13.969ZM11.1328 14.4084L10.2043 13.0804L2.81684 2.5134H5.99736L11.9592 11.0413L12.8876 12.3693L20.6373 23.4543H17.4567L11.1328 14.4089V14.4084Z",
    fill: "#CDD5DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.4719,
    height: 24,
    fill: "white",
    transform: "translate(0 0.95459)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgXLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/x-logo.1f4e18dc291c61df2ce0600086a9aa3d.svg";